module.exports = __webpack_public_path__ + "assets/9d304c44901e3746bdf9788e3092bd0b.png";